
function HeaderClinica(){
    return (
    <div className="md:text-center">
      <h1 className=" bg-blue-400  font-extrabold capitalize md:uppercase">Clínica Goodhealth</h1>
      </div>
    );
  }
export default HeaderClinica